export default {
    "work-data": "Work data",
    "day-off-request": "Day off request",
    "materials": "Materials",
    "rates": "Rates",
    "employee-is-edited": "employee is edited"
}